import React from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CForm,
  CFormSelect,
  CFormInput,
  CRow,
  CCol,
  CFormLabel,
} from "@coreui/react";

const StockFilter = ({ open, onClose, onApply, initialFilters }) => {
  const [filters, setFilters] = React.useState(initialFilters);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply(filters);
  };

  const handleReset = () => {
    setFilters({
      store: "",
      category: "",
      stockStatus: "",
      timeRange: "monthly",
    });
  };

  return (
    <CModal visible={open} onClose={onClose} size="lg">
      <CModalHeader>
        <CModalTitle>Filter Stock Data</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol md={6}>
              <CFormLabel>Store</CFormLabel>
              <CFormInput
                type="text"
                name="store"
                value={filters.store}
                onChange={handleInputChange}
                placeholder="Filter by store name"
              />
            </CCol>
            <CCol md={6}>
              <CFormLabel>Category</CFormLabel>
              <CFormSelect name="category" value={filters.category} onChange={handleInputChange}>
                <option value="">All Categories</option>
                <option value="Electronics">Electronics</option>
                <option value="Clothing">Clothing</option>
                <option value="Groceries">Groceries</option>
                <option value="Home Goods">Home Goods</option>
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={6}>
              <CFormLabel>Stock Status</CFormLabel>
              <CFormSelect name="stockStatus" value={filters.stockStatus} onChange={handleInputChange}>
                <option value="">All Statuses</option>
                <option value="in_stock">In Stock</option>
                <option value="out_of_stock">Out of Stock</option>
                <option value="low_stock">Low Stock</option>
              </CFormSelect>
            </CCol>
            <CCol md={6}>
              <CFormLabel>Time Range</CFormLabel>
              <CFormSelect name="timeRange" value={filters.timeRange} onChange={handleInputChange}>
                <option value="weekly">Last 7 Days</option>
                <option value="biweekly">Last 14 Days</option>
                <option value="monthly">Last 30 Days</option>
                <option value="quarterly">Last 90 Days</option>
              </CFormSelect>
            </CCol>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleReset}>
          Reset
        </CButton>
        <CButton color="primary" onClick={handleSubmit}>
          Apply Filters
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default StockFilter;
